import { render, staticRenderFns } from "./BusGisPrizeList.vue?vue&type=template&id=98a991f0&scoped=true&"
import script from "./BusGisPrizeList.vue?vue&type=script&lang=js&"
export * from "./BusGisPrizeList.vue?vue&type=script&lang=js&"
import style0 from "./BusGisPrizeList.vue?vue&type=style&index=0&id=98a991f0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98a991f0",
  null
  
)

export default component.exports